<template>
  <v-row>
    <v-col cols="12">
      <div v-for="(otherAsset, index) in otherAssets" :key="index">
        <div class="list-item">
          <v-btn
            class="list-item-btn"
            :ripple="false"
            block
            color="white"
            @click.stop="(showDialog = true), (otherAssetToUpdate = otherAsset)"
          >
            <div class="list-item-text">
              <span class="list-item-name">{{ otherAsset.description }}</span>
            </div>
          </v-btn>
        </div>
      </div>
      <div class="mt-5 mb-5">
        <AlternativeButton
          :title="'Add other asset'"
          @gradientButtonClicked="addOtherAssetClicked"
        />
      </div>
    </v-col>
    <OtherAssetDialog
      v-model="showDialog"
      :other-asset-to-update="otherAssetToUpdate"
    />
  </v-row>
</template>

<script>
  import OtherAssetDialog from './OtherAssetDialog.vue';

  export default {
    name: 'OtherAssetsList',
    components: {
      OtherAssetDialog,
    },
    props: {
      otherAssets: {
        required: true,
        type: Array,
      },
    },
    data() {
      return {
        showDialog: false,
        otherAssetToUpdate: {},
      };
    },
    methods: {
      addOtherAssetClicked() {
        this.otherAssetToUpdate = {};
        this.showDialog = true;
        this.sendGADataLayer('add-other-asset');
      },
      sendGADataLayer(event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: event,
          omuserid: this.$store.getters?.userId,
        });
      },
    },
  };
</script>
